export let medicion: any[] = [
  {
    id: 1,
    nombre: 'Ruido Ambiental',
    desc: 'Se llama contaminación acústica o contaminación sonora al exceso de sonido que altera las condiciones normales del ambiente en una determinada zona. Si bien el ruido no se acumula, traslada o mantiene en el tiempo como las otras contaminaciones, también puede causar grandes daños en la calidad de vida de las personas si no se controla bien o adecuadamente.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 2,
    nombre: 'Ruido Ocupacional',
    desc: 'Se conoce como ruido laboral a la contaminación acústica que se genera en un sector de trabajo y que afecta principalmente a los trabajadores del lugar. Se trata de uno de los motivos más frecuentes de discapacidad.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 3,
    nombre: 'Iluminación',
    desc: 'Es la acción o efecto de iluminar. En la técnica se refiere al conjunto de dispositivos que se instalan para producir ciertos efectos luminosos, tanto prácticos como decorativos.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 4,
    nombre: 'Eficiencia energética',
    desc: 'La eficiencia energética es una práctica que tiene como objetivo reducir el consumo de energía. La eficiencia energética es el uso eficiente de la energía, de esta manera optimizar los procesos productivos y el empleo de la energía utilizando lo mismo o menos para producir más bienes y servicios.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 5,
    nombre: 'Estrés térmico',
    desc: 'Es la sensación de malestar que se experimenta cuando la permanencia en un ambiente determinado exige esfuerzos desmesurados a los mecanismos de que dispone el organismo para mantener la temperatura interna, mientras se efectúa el intercambio de agua y demás sustancias.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 6,
    nombre: 'Flujos de aire',
    desc: 'Se refiere al flujo por la cantidad de aire (u otro fluido) que atraviesa una dada superficie en un tiempo dado. La superficie puede ser real (como la sección transversal de una tubería) o imaginaria (por ejemplo si hay viento y considero una superficie vertical imaginaria de 1m² y analizo la cantidad de aire que pasa por él).',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 7,
    nombre: 'Niveles de CO2',
    desc: 'Niveles de gas cuyas moléculas están compuestas por dos átomos de oxígeno y uno de carbono. Es soluble en agua cuando la presión se mantiene constante y normalmente se encuentra en la naturaleza en forma gaseosa, pero cuando se le somete a una presión y temperatura considerable baja se vuelve líquido y llega a ser sólido formando lo que se denomina hielo seco o nieve carbónica.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 8,
    nombre: 'Vibraciones',
    desc: 'Propagación de ondas elásticas produciendo deformaciones y tensiones sobre un medio continuo (o posición de equilibrio).',
    img: 'assets/img/app/appimg5.png'
  }
];



// WEBPACK FOOTER //
// G:/proyectos/website - IntergraMAI/webMai/src/assets/medicion.data.ts